import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useLoadInteractionTagOptions = () => {
  const { generalApiCall } = useGeneralApiCall();

  const loadTagOptions = async (term) => {
    const results = await generalApiCall({
      method: 'get',
      pathname: `/api/autocomplete/crm-interaction-tag?term=${encodeURIComponent(term ?? '')}`,
      needsAuthentication: true,
      notShowErrorMessage: true,
    });
    return results ?? [];
  };

  return loadTagOptions;
};

export default useLoadInteractionTagOptions;
